var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrashBinIcon = function SvgTrashBinIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash-bin-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D14339",
    d: "M8.037 21.257a2.08 2.08 0 0 0 2.074 2.074h8.296a2.08 2.08 0 0 0 2.075-2.074V8.812H8.037zM21.518 5.7h-3.63l-1.036-1.037h-5.185L10.63 5.701H7v2.074h14.519z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trash-bin-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrashBinIcon);
export default ForwardRef;